import React from 'react'
import './styles/main.scss'
import './styles/fonts.css'

import { CssBaseline, responsiveFontSizes, ThemeProvider } from '@mui/material'
import { theme } from './src/muiTheme'

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={responsiveFontSizes(theme)}>
    <CssBaseline />
    {element}
  </ThemeProvider>
)
